module.exports = __webpack_public_path__ + "img/home-4.8ac60579.webp";